import "./services.css";
import { ServiceCategoryItem } from "../serviceItem/ServiceCategoryItem";
import { servicesCategories } from "./../../barberData";
import { useState } from "react";
import { getEmployeesByLevel } from "../../models/employees";

export const Services = () => {
const [level, setLevel] = useState("junior"); // junior, regular, master

  return (
    <div className="servicesWrapper" id="sluzby">
      <div className="services">
        <h1 className="sluzby">SLUŽBY A CENY - {level.toUpperCase()}  ({getEmployeesByLevel(level)})</h1>
        <hr className="headerUnderline" />
        <div className="levelSelector">
          <select 
            value={level} 
            onChange={(e) => setLevel(e.target.value)}
            className="levelSelect"
          >
            <option value="junior">Junior</option>
            <option value="regular">Regular</option>
            <option value="master">Master</option>
          </select>
        </div>
        <caption className="servicesCaption">
          
        </caption>
        <span>
          <p>Ke všem službám je voda a parfém samozřejmostí. <br /> Po každém
          střihu získáváte styling zdarma.</p>
          <p style={{fontSize: "10px"}}>Ceny jsou platné od 10. února 2026 a mohou lišit v závislosti na zvoleném barberovi.</p>
        </span>
        {servicesCategories.map((serviceCategory) => (
          <ServiceCategoryItem
            level={level}
            serviceCategory={serviceCategory}
            key={serviceCategory.id}
          />
        ))}

      </div>
    </div>
  );
};
